import { facebook_pixel_context_value } from '../types';

export function createDefaultFacebookPixelContextValue(): facebook_pixel_context_value {
    return { id: undefined, actions: undefined };
}

export default createDefaultFacebookPixelContextValue;
